"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewModeActions = exports.useGenericActions = exports.useEditModeActions = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRouterDom = require("react-router-dom");
var _pages = require("@mulesoft/exchange-ui-portals-store/lib/domains/pages");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _ConfirmPublishModal = _interopRequireDefault(require("../ConfirmPublishModal"));
var _DiscardDraftModal = _interopRequireDefault(require("../DiscardDraftModal"));
var _routes = require("../../../utils/routes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useGenericActions = exports.useGenericActions = function useGenericActions() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    openModal = _useModals.openModal;
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var push = (0, _exchangeReactHooks.usePush)();
  var asset = (0, _exchangeReactHooks.useAsset)();
  var isEdit = (0, _exchangeReactHooks.useIsPortalEdit)();
  var _useParams = (0, _reactRouterDom.useParams)(),
    pagePathParam = _useParams.pagePath;
  var pageEditorState = (0, _reactRedux.useSelector)(function (state) {
    return _pages.selectors.pageEditorState(state, _objectSpread(_objectSpread({}, asset), {}, {
      pagePath: decodeURIComponent(pagePathParam)
    }));
  });
  var publishedURL = getPath('page', (0, _routes.getPageParams)(asset, config.defaultPageName));
  var onSave = _react.default.useCallback( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var pagePath, groupId, assetId, version, minorVersion, versionGroup, type, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          pagePath = pageEditorState.pagePath;
          groupId = asset.groupId, assetId = asset.assetId, version = asset.version, minorVersion = asset.minorVersion, versionGroup = asset.versionGroup, type = asset.type;
          if (!(0, _routes.pageHasBeenRenamed)(pageEditorState)) {
            _context.next = 7;
            break;
          }
          _context.next = 5;
          return dispatch(_pages.actions.renamePage({
            pageName: pageEditorState.pageName,
            oldPagePath: pageEditorState.pagePath,
            pagePath: pageEditorState.pageName,
            groupId: groupId,
            assetId: assetId,
            version: version,
            minorVersion: minorVersion,
            versionGroup: versionGroup,
            getPath: getPath,
            pushFn: push
          }));
        case 5:
          response = _context.sent;
          // after successful update we want to redirect to updated page
          pagePath = response.pagePath;
        case 7:
          _context.next = 9;
          return dispatch(_pages.actions.savePage({
            groupId: groupId,
            assetId: assetId,
            version: version,
            minorVersion: minorVersion,
            versionGroup: versionGroup,
            type: type,
            pagePath: pagePath,
            markdown: pageEditorState.pageContent,
            getPath: getPath,
            pushFn: push
          }));
        case 9:
          return _context.abrupt("return", pagePath);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [asset, dispatch, getPath, pageEditorState, push]);
  var onPublishConfirm = _react.default.useCallback( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(closeModal) {
      var groupId, assetId, version, pagePath, newPagePath;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            groupId = asset.groupId, assetId = asset.assetId, version = asset.version;
            pagePath = pageEditorState.pagePath;
            if (!isEdit) {
              _context2.next = 6;
              break;
            }
            _context2.next = 5;
            return onSave();
          case 5:
            pagePath = _context2.sent;
          case 6:
            _context2.next = 8;
            return dispatch(_portals.actions.publishAsset({
              groupId: groupId,
              assetId: assetId,
              version: version,
              isEditMode: isEdit
            }));
          case 8:
            if (isEdit) {
              closeModal({
                publishDraft: true
              });
            }
            newPagePath = getPath('page', (0, _routes.getPageParams)(asset, pagePath));
            push(newPagePath);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [asset, dispatch, getPath, isEdit, onSave, pageEditorState, push]);
  var onPublishWithModal = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            openModal(_ConfirmPublishModal.default, {
              onPublishConfirm: onPublishConfirm
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onPublishWithModal() {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    onSave: onSave,
    onPublish: isEdit ? onPublishWithModal : onPublishConfirm,
    pageEditorState: pageEditorState,
    publishedURL: publishedURL
  };
};
var useEditModeActions = exports.useEditModeActions = function useEditModeActions(hasUnpublishedChanges) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var push = (0, _exchangeReactHooks.usePush)();
  var asset = (0, _exchangeReactHooks.useAsset)();
  var _useGenericActions = useGenericActions(),
    onPublish = _useGenericActions.onPublish,
    onSave = _useGenericActions.onSave,
    publishedURL = _useGenericActions.publishedURL,
    pageEditorState = _useGenericActions.pageEditorState;
  var onCancel = _react.default.useCallback( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return dispatch(_pages.actions.updatePageContentStatus({
            hasUnsavedChanges: false
          }));
        case 2:
          if (!hasUnpublishedChanges) {
            push(getPath('page', (0, _routes.getPageParams)(asset, config.defaultPageName)));
          } else {
            push(getPath('pageDraft', (0, _routes.getPageParams)(asset, pageEditorState.pagePath)));
          }
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [asset, config.defaultPageName, getPath, push, pageEditorState === null || pageEditorState === void 0 ? void 0 : pageEditorState.pagePath, dispatch, hasUnpublishedChanges]);
  return {
    publishedURL: publishedURL,
    onCancel: onCancel,
    onSave: onSave,
    onPublish: onPublish
  };
};
var useViewModeActions = exports.useViewModeActions = function useViewModeActions() {
  var _useModals2 = (0, _exchangeReactHooks.useModals)(),
    openModal = _useModals2.openModal;
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var asset = (0, _exchangeReactHooks.useAsset)();
  var _useGenericActions2 = useGenericActions(),
    onPublish = _useGenericActions2.onPublish,
    publishedURL = _useGenericActions2.publishedURL,
    pageEditorState = _useGenericActions2.pageEditorState;
  var editURL = getPath('pageEdit', (0, _routes.getPageParams)(asset, pageEditorState.pagePath));
  var onDiscard = _react.default.useCallback(function () {
    openModal(_DiscardDraftModal.default);
  }, [openModal]);
  return {
    publishedURL: publishedURL,
    editURL: editURL,
    onDiscard: onDiscard,
    onPublish: onPublish
  };
};
//# sourceMappingURL=hooks.js.map